import request from "../util/request";
import {APP_KEY,API_URL,WEB_CODE} from "../util/constants";

export function getXueyuanListRequest(class_code, callback) {
    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("caozuo", "jsxueke");
    formData.append("teacher_phone", sessionStorage.getItem('teacherphone'));
    formData.append("class_code", class_code);

    return fetch(API_URL+'/dianzan/index',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}

export function getReasonListRequest(class_code,xueke_code, callback) {
    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("caozuo", "jszhibiao");
    formData.append("xueke_code", xueke_code);
    formData.append("class_code", class_code);
    formData.append("laodong", "new");

    return fetch(API_URL+'/dianzan/index',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}
export function getStudentEvaluationRequest(class_code,page, callback) {
    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("teacherphone", sessionStorage.getItem('teacherphone'));
    formData.append("liyou", '0');//全部
    formData.append("classcode", class_code);
    formData.append("limit", '10');//全部
    formData.append("offset", page);

    return fetch(API_URL+'/js/cdianzans',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}

export function deleteStudentEvaluationRequest(dongtai_id,dianzan_type,class_code,student_pid,dianzan_code, callback) {
    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("dongtai_id", dongtai_id);
    formData.append("dianzan_type", dianzan_type);//全部
    formData.append("class_code", class_code);
    formData.append("student_pid", student_pid);//全部
    formData.append("dianzan_code", dianzan_code);

    return fetch(API_URL+'/dianzan/deldianzan',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}

export function dianzanStudentDanRequest(studentid,dianzan_code,dz_xueke, callback) {
    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("teacherphone", sessionStorage.getItem('teacherphone'));
    formData.append("liyou", dianzan_code);
    formData.append("type", "1");//区分积极向上1和有待改进2
    formData.append("studentid", studentid);//全部
    formData.append("dz_xueke", dz_xueke);

    return fetch(API_URL+'/dianzan/dianzan',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}

export function dianzanStudentDuoRequest(studentid,dianzan_code,dz_xueke, callback) {
    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("teacherphone", sessionStorage.getItem('teacherphone'));
    formData.append("liyou", dianzan_code);
    formData.append("dianzan_type", "1");//区分积极向上1和有待改进2
    formData.append("studentid", studentid);//全部
    formData.append("dz_xueke", dz_xueke);

    return fetch(API_URL+'/dianzan/dianzan_duoxuan',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}

export function getClassReasonListRequest(banji_type, callback) {
    let formData = new FormData();
    formData.append("appkey", "douhao1p4");
    formData.append("banji_type", banji_type);

    return fetch(API_URL+'/js_classguanli/classguanli_pjliyou',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}

export function pingjiaClassRequest(class_code,type,liyou, callback) {
    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("teacherphone", sessionStorage.getItem('teacherphone'));
    formData.append("liyou", liyou);
    formData.append("type", type);//区分积极向上1和有待改进2
    formData.append("class_code", class_code);

    return fetch(API_URL+'/dianzan/dianzan_class',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}
export function getClassEvaluationRequest(class_code,page, callback) {
    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("teacherphone", sessionStorage.getItem('teacherphone'));
    formData.append("liyou", '0');//全部
    formData.append("classcode", class_code);
    formData.append("limit", '10');//全部
    formData.append("offset", page);

    return fetch(API_URL+'/js/fdianzans',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}

export function deleteClassEvaluationRequest(dongtai_id,dianzan_type,class_code, callback) {
    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("dongtai_id", dongtai_id);
    formData.append("dianzan_type", dianzan_type);//全部
    formData.append("class_code", class_code);

    return fetch(API_URL+'/dianzan/deldianzan_class',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}

export function getBadgeListRequest(class_code,page, callback) {
    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("teacherphone", sessionStorage.getItem('teacherphone'));
    formData.append("hztype", '0');//全部
    formData.append("hzxueke", '0');//全部
    formData.append("classcode", class_code);
    formData.append("limit", '10');//全部
    formData.append("offset", page);

    return fetch(API_URL+'/js/chuizhangs',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}
//获取一级指标学院和学院下学科接口
export function getZhibiao1Request(class_code, callback) {
    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("caozuo", "jsxueke");
    formData.append("teacher_phone", sessionStorage.getItem('teacherphone'));
    formData.append("class_code", class_code);

    return fetch(API_URL+'/Zhibiao/index',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}
//获取二级指标列表
export function getZhibiao2Request(xueke_code, callback) {
    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("caozuo", "get_erji_zhibiao");
    formData.append("xueke_code", xueke_code);


    return fetch(API_URL+'/Zhibiao/index',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}

//获取三级指标列表
export function getZhibiao3Request(erji_zhibiao_code, callback) {
    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("caozuo", "get_sanji_zhibiao");
    formData.append("erji_zhibiao_code", erji_zhibiao_code);


    return fetch(API_URL+'/Zhibiao/index',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}

//获取一级指标排名
export function getZhibiao1PaimingRequest(class_code,xueke_code,tongji_code, callback) {
    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("caozuo", "get_yiji_paiming");
    formData.append("xueke_code", xueke_code);
    formData.append("class_code", class_code);
    formData.append("tongji_code", tongji_code);

    // formData.append("laodong", "new");

    return fetch(API_URL+'/Zhibiao/index',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}
//获取二级指标排名
export function getZhibiao2PaimingRequest(class_code,erji_zhibiao_code,tongji_code, callback) {
    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("caozuo", "get_erji_paiming");
    formData.append("erji_zhibiao_code", erji_zhibiao_code);
    formData.append("class_code", class_code);
    formData.append("tongji_code", tongji_code);

    // formData.append("laodong", "new");

    return fetch(API_URL+'/Zhibiao/index',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}
//获取三级指标排名
export function getZhibiao3PaimingRequest(class_code,sanji_zhibiao_code,tongji_code, callback) {
    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("caozuo", "get_sanji_paiming");
    formData.append("sanji_zhibiao_code", sanji_zhibiao_code);
    formData.append("class_code", class_code);
    formData.append("tongji_code", tongji_code);

    // formData.append("laodong", "new");

    return fetch(API_URL+'/Zhibiao/index',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}
